// extracted by mini-css-extract-plugin
module.exports = {"perfil":"Configuracao_perfil__2ZZyi","foto":"Configuracao_foto__1BMFk","nome":"Configuracao_nome__18KTF"};